var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClearDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8033 20.1823C12.5473 20.1823 12.2913 20.0849 12.0967 19.8889C11.706 19.4983 11.706 18.8663 12.0967 18.4756L18.486 12.0863C18.8767 11.6956 19.5087 11.6956 19.8993 12.0863C20.29 12.4769 20.29 13.1089 19.8993 13.4996L13.51 19.8889C13.3153 20.0849 13.0593 20.1823 12.8033 20.1823Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1953 20.1861C18.9393 20.1861 18.6833 20.0888 18.4887 19.8928L12.094 13.4968C11.7033 13.1061 11.7033 12.4741 12.094 12.0835C12.486 11.6928 13.118 11.6928 13.5073 12.0835L19.902 18.4795C20.2927 18.8701 20.2927 19.5021 19.902 19.8928C19.7073 20.0888 19.45 20.1861 19.1953 20.1861Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearDate);
export default __webpack_public_path__ + "static/media/iconClearDate.c322d5bc753da78197debb83d8d4c6d3.svg";
export { ForwardRef as ReactComponent };